import { useState, useEffect } from 'react';

// CSRF tokens are not needed with JWT Bearer auth.
// Kept as a no-op to avoid breaking all existing imports — always returns empty string.

let cachedCsrfToken = '';

export const clearCsrfToken = () => {
    cachedCsrfToken = '';
};

export const getCsrfToken = async () => {
    return cachedCsrfToken;
};

const useCsrfToken = () => {
    const [csrfToken, setCsrfToken] = useState(cachedCsrfToken);

    useEffect(() => {
        setCsrfToken('');
    }, []);

    return csrfToken;
};

export default useCsrfToken;
